export const SEARCH_SESSION_STORAGE_KEY = "pubmed-search-state";
export const SEARCH_HISTORY_VIEW_STORAGE_KEY = "pubmed-history-view";

export class SearchUiStorageError extends Error {
  constructor(message, failures) {
    super(message);
    this.name = "SearchUiStorageError";
    this.failures = failures;
  }
}

export function clearSearchUiStorage() {
  if (typeof window === "undefined") {
    return;
  }

  const failures = [];

  try {
    window.sessionStorage.removeItem(SEARCH_SESSION_STORAGE_KEY);
  } catch (error) {
    failures.push({ storage: "sessionStorage", error });
  }

  try {
    window.localStorage.removeItem(SEARCH_HISTORY_VIEW_STORAGE_KEY);
  } catch (error) {
    failures.push({ storage: "localStorage", error });
  }

  if (failures.length > 0) {
    throw new SearchUiStorageError(
      "Failed to clear persisted search UI state.",
      failures,
    );
  }
}
